import Vue from 'vue'
import injector from 'vue-inject'

require('../../start')

Vue.use(injector)

let api = injector.get('api')

const state = {
    auth: false,
    confirmations: {
        google: false
    },
    isBanned: null,
    location: null,
    loginForm: {
        view: 2
    },
    twoStepVerification: false
};

const getters = {
    /**
     * Check is logged in
     * @param state
     * @returns {boolean|*}
     */
    checkAuth : state => state.auth,

    isBanned : state => state.isBanned,

    location : state => state.location,

    loginForm: state => state.loginForm,

    checkTwoStepVerification : state => state.twoStepVerification
};

const mutations = {
    banned (state, isBanned) {
        Vue.set(state, 'isBanned', isBanned)
    },

    location (state, location) {
        Vue.set(state, 'location', location)
    },

    loginUser (state) {
        Vue.set(state, 'auth', true)
    },

    logoutUser (state) {
        Vue.set(state, 'auth', false)
    },

    confirmTwoStepVerification (state) {
        Vue.set(state, 'twoStepVerification', true)
    },

    loginFormData (state, params) {
        Vue.set(state.loginForm, params.name, params.value)
    },

    loginFormView (state, view) {
        Vue.set(state.loginForm, 'view', view)
    }
};

const actions = {
    loginUser ({ commit }) {
        commit('loginUser')
    },

    /**
     * Logout user
     * @param commit
     */
    logoutUser ({ commit }) {
        return new Promise((resolve, reject) => {
            Vue.http.get(api.auth.logout).then(() => {
                commit('logoutUser')
                resolve()
            }, () => {
                reject()
            })
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/authentication.js